import { render } from "./MainReportSales.vue?vue&type=template&id=5e401917&scoped=true"
import script from "./MainReportSales.vue?vue&type=script&lang=js"
export * from "./MainReportSales.vue?vue&type=script&lang=js"

import "./MainReportSales.vue?vue&type=style&index=0&id=5e401917&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e401917"]])

export default __exports__